module.exports = __webpack_public_path__ + "img/private-napolimania-pasta-1.411029d9.jpg";